module.exports = __webpack_public_path__ + "static/media/12.121.ee232103.webp";